import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";

function We() {
  const data = [
    {
      id: 1,
      img: "assets/images/resources/testi-h4-1.png",
      name: "Richard M. Pappas",
    },
    {
      id: 2,
      img: "assets/images/resources/testi-h4-1.png",
      name: "Richard M. Pappas",
    },
    {
      id: 3,
      img: "assets/images/resources/testi-h4-1.png",
      name: "Richard M. Pappas",
    },
    {
      id: 4,
      img: "assets/images/resources/testi-h4-1.png",
      name: "Richard M. Pappas",
    },
  ];

  return (
    <>
      <section
        className="testimonials-three"
        style={{
          backgroundImage: "url(assets/images/shapes/testi-3-bg-1.jpg)",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-xl-3 d-flex">
              <div className="my-auto">
                <div className="testimonials-three__circle">
                  <i className="flaticon-quote-1" />
                  <img src="assets/images/resources/testi-3-c-1.png" alt="" />
                  <img src="assets/images/resources/testi-3-c-2.png" alt="" />
                  <img src="assets/images/resources/testi-3-c-3.png" alt="" />
                  <img src="assets/images/resources/testi-3-c-4.png" alt="" />
                </div>
              </div>
            </div>

            <div className="col-xl-6">
              <div className="testimonials-three__carousel">
                <Swiper
                  loop={true}
                  spaceBetween={30}
                  slidesPerView={1}
                >
                  {data.map((item) => (
                    <SwiperSlide key={item.id}>
                      <div className="testimonials-three__card">
                        <p className="testimonials-three__card__text">
                          We denounce with righteous indignation and dislike
                          beguiled to demoralized by the charms of pleasure the
                          moment desire they cannot foresee the pain trouble
                          systems
                        </p>

                        <div className="testimonials-three__card__info">
                          <div className="testimonials-three__card__image">
                            <img src={item.img} alt={item.name} />
                          </div>

                          <div className="testimonials-three__card__info__content">
                            <h3 className="testimonials-three__card__name">
                              {item.name}
                            </h3>

                            <p className="testimonials-three__card__designation">
                              Senior Manager
                            </p>
                          </div>
                        </div>

                        <div className="testimonials-three__card__review">
                          <h3 className="testimonials-three__card__review__title">
                            Quality Services
                          </h3>

                          <div className="testimonials-three__card__review__stars">
                            <i className="fas fa-star" />
                            <i className="fas fa-star" />
                            <i className="fas fa-star" />
                            <i className="fas fa-star" />
                            <i className="fas fa-star" />
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>

            <div className="col-xl-3">
              <div
                className="testimonials-three__image wow fadeInUp"
                data-wow-duration="1500ms"
              >
                <img src="assets/images/resources/testi-h4-2.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="cta-four">
        <div className="container">
          <div className="row gutter-y-60">
            <div className="col-lg-6">
              <div className="cta-four__image clearfix">
                <img src="assets/images/resources/cta-4-1.png" alt="" />
              </div>
            </div>

            <div className="col-lg-6 d-flex">
              <div className="my-auto">
                <div className="cta-four__content">
                  <div className="sec-title text-start">
                    <p className="sec-title__tagline">Download app</p>

                    <h3 className="sec-title__title">
                      We are Available on store download app now
                    </h3>
                  </div>

                  <div className="cta-four__text">
                    We denounce with righteous indignation and dislike men
                    beguiled to and demoralized by the charms of pleasure the
                    moment desire is they they cannot foresee the pain and
                    trouble that are bound
                  </div>

                  <div className="cta-four__btns">
                    <a href="#" className="thm-btn cta-four__btn">
                      <span>
                        Google Play
                        <i className="fab fa-google-play" />
                      </span>
                    </a>

                    <a
                      href="#"
                      className="thm-btn thm-btn--three cta-four__btn cta-four__btn--two"
                    >
                      <span>
                        Windows
                        <i className="fab fa-windows" />
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default We;
